import {createApp} from 'vue'

import store from '@/vuex/index.js'

import router from '@/router/base/index.js';

import App from './App.vue'

// DSRYU20260919 START
// 아래 내용 추가
// Axios 401 응답 처리 함수를 앱의 Vuex와 Router에 연결한다.
import { setUnauthorizedHandler } from '@/services/base/index.js'
// DSRYU20260919 END

import Vuelidate from 'vuelidate';


import req_patient from '@/globals/req_patient.js' // [global]




import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// import moment from 'moment'

// Create Vue Instance
const app = createApp(App);

// app.filter('formatDate',function(value){
//     if (value){
//         return moment(String(value)).format('YYYYMMDD')
//     }
// })


//app.config.compilerOptions.isCustomElement = (tag) => { return tag !== 'font'; };

app.use(Vuelidate)
// DSRYU20260919 START
// 아래 내용 기존 즉시 mount에서 JWT 사용자 정보 복원 후 mount하도록 수정
// 수정전 주석 처리, 수정 후 주석 해제
// app.use(store).use(router).use(req_patient).mount('#app')
setUnauthorizedHandler(async () => {
    await store.dispatch('userStore/logout')
    if (router.currentRoute.value.path !== '/login') {
        await router.replace('/login')
    }
})

async function initializeApp() {
    await store.dispatch('userStore/restoreSession')
    app.use(store).use(router).use(req_patient).mount('#app')
}

initializeApp()
// DSRYU20260919 END

// new Vue({
//     el: "#app",
//     render: h => h(App),
//     store,
//     router,
//     Vuelidate
// })